import type { ThemeOptions } from '@mui/material';
import { palette } from './palette';

export const colorSchemes: ThemeOptions['colorSchemes'] = {
  v4: {
    palette: palette.v4,
  },
};
